import type { ErrorCopyFor } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";
import type { INTEGRATION_ERROR_CODES } from "@amtana/integration-contract";

// What a user reads when connecting an app fails (packages/module ADR-001).

const EN = {
  invalidKeyTitle: "That API key was rejected",
  invalidKeyDescription: "Copy it again from the other tool and paste it here.",
} as const;

const ES: Translation<typeof EN> = {
  invalidKeyTitle: "Esa clave de API fue rechazada",
  invalidKeyDescription: "Cópiala de nuevo desde la otra herramienta y pégala aquí.",
};

export const INTEGRATION_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const INTEGRATION_ERROR_COPY = {
  integration_invalid_key: {
    title: phrase(INTEGRATION_ERROR_CATALOGS, "invalidKeyTitle"),
    description: phrase(INTEGRATION_ERROR_CATALOGS, "invalidKeyDescription"),
  },
} satisfies ErrorCopyFor<typeof INTEGRATION_ERROR_CODES>;
